




































































import { shortTimeAgo } from '@/helpers/date-utils';
import { CopyToClipboard } from '@/mixins/copy-to-clipboard';
import { DISCOUNT_TYPE, OFFER_TYPE } from '@/store/shared';
import { ISession } from '@/store/types';
import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'MiniSession',
  mixins: [CopyToClipboard],
  props: {
    session: {
      type: Object as PropType<ISession>,
    },
  },
  data() {
    return {
      OFFER_TYPE,
      DISCOUNT_TYPE,
      shortTimeAgo,
    };
  },
  computed: {
    ...mapGetters(['surveyChoices']),
  },
  methods: {
    view(session: ISession) {
      this.$emit('view', session);
    },
  },
});
